module.exports = __webpack_public_path__ + "65c8f14b2797c71d662630edc841cc8c.svg";